import * as csrContextFields from './constants.js';

/**
 * useExposeCsrContext
 * @param {string} key - key of the csr context
 * @param {object} data - data to be exposed
**/
export function useExposeCsrContext ({ key, data }) {

  if (Object.keys(window.csr).length === 0 && window.csr.constructor === Object) {
    const csrContext = Object.preventExtensions(Object.values(csrContextFields).reduce((acc, field) => {
      acc[field] = {};
      return acc;
    }, {}));
    window.csr = csrContext;
  }

  if (!key) {
    throw new Error("useExposeCsrContext: key is required");
  }

  if (!(key in window.csr)) {
    throw new Error(`useExposeCsrContext: key '${key}' is not defined in csr context`);
  }

  window.csr[key] = {
    ...window.csr[key],
    ...data,
  };
  
}